
export const formatEur = (number, digits=2) => {
  return number.toFixed(digits).replace('.',',')
}